import { has as xHas } from 'lodash';

export class ViewPoint extends DOMPoint {

    constructor(x, y) {
        super(x, y);

        this._id = 0;
        this._name = "";
    }

    static make(from) {
        const inst = new ViewPoint(0, 0);

        // if (xHas(from, "x"))
            inst.x = from.x;
        // if (xHas(from, "y"))
            inst.y = from.y;
        // if (xHas(from, "id"))
            inst.id = from.id;
        // if (xHas(from, "name"))
            inst.name = from.name;

        return inst;
    }

    get id() { return this._id; }

    set id(value) { this._id = value; }

    get name() { return this._name; }

    set name(value) { this._name = value; }
}